import { Link, useNavigate, useParams, Outlet } from 'react-router-dom';
import { useLocation } from 'react-router';
import { Grid, IconButton, List, ListSubheader, Tab, Tabs, Tooltip, Typography, Box } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useGetOrganizationQuery } from '../features/api/rest/apiOrganizationsSlice';

function Organization() {
  const { opk } = useParams();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data: org = [] } = useGetOrganizationQuery(opk);
  const backToOrg = () => {
    navigate('/profile/organizations/');
  };

  const menuStyle = {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'top',
    justifyContent: 'left',
    gap: 1,
    backgroundColor: 'white',
    zIndex: 1,
    marginTop: '-30px',
    paddingTop: '70px',
    width: 'calc(100% + 30px)',
    ml: '-15px',
    pl: '15px',
  };

  return (
    <Box position="relative">
      <Typography variant="h4" py={0.5} noWrap sx={{ position: 'absolute', top: 0, zIndex: 2 }}>
        {org.name}
      </Typography>
      <List>
        <ListSubheader sx={{ p: 0 }}>
          <Grid container sx={menuStyle}>
            <Grid item>
              <Tooltip title={t('organizations.backOrganizations')} placement="bottom">
                <IconButton onClick={backToOrg}>
                  <ArrowBackIcon fontSize="large" />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item flex={1} minWidth={0}>
              <Tabs value={pathname} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons={false} sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tab label={t('organizations.product.products')} component={Link} to={`products`} value={`/profile/organizations/${opk}/products`} />
                <Tab label={t('organizations.brand.brands')} component={Link} to={`brands`} value={`/profile/organizations/${opk}/brands`} />
                <Tab label={t('organizations.user.users')} component={Link} to={`users`} value={`/profile/organizations/${opk}/users`} />
              </Tabs>
            </Grid>
          </Grid>
        </ListSubheader>
        <Outlet />
      </List>
    </Box>
  );
}

export default Organization;
